import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AppInfo } from "../types";
import { Modal, Empty, Tooltip, Button } from "antd";
import { AppTypeTag } from "@/components/AppTypeTag";
import styles from "./styles.module.less";

export interface PCAndPadAddAppProps {
  allApps: AppInfo[];
  orderedApps: AppInfo[];
  visible: boolean;
  onCancel: () => void;
  removeApp: (v: AppInfo) => Promise<any>;
  installApp: (id: string) => Promise<void>;
}

export const PCAndPadAddApp: FC<PCAndPadAddAppProps> = ({
  allApps,
  orderedApps,
  visible,
  onCancel,
  removeApp,
  installApp,
}) => {
  const { t } = useTranslation();

  const isInstalled = useCallback(
    (id: string) => {
      return orderedApps.some((item) => item.id.split("/")[0] === id);
    },
    [orderedApps]
  );

  return (
    <Modal
      title={t("common.installApp")}
      visible={visible}
      width={806}
      bodyStyle={{
        minHeight: 300,
        maxHeight: "78vh",
        overflow: "auto",
      }}
      footer={false}
      onCancel={onCancel}
    >
      {allApps.length ? (
        <div className={styles.store}>
          {allApps.map((v: any) => (
            <div key={v.id} className={styles.item}>
              <img className={styles.logo} src={v.logo} alt="" />
              <div className={styles.appNameAndDesc}>
                <div className={styles.appNameContainer}>
                  <h3 title={v.name} className={styles.appName}>
                    {v.name}
                  </h3>
                  <AppTypeTag
                    type={v.isIntegrate ? "integrate" : "selfBuilt"}
                  />
                </div>
                <Tooltip title={v.description}>
                  <p title={v.description}>
                    {v.description || t("common.noDescNow")}
                  </p>
                </Tooltip>
              </div>
              {isInstalled(v.id) ? (
                <Button
                  type="default"
                  size="small"
                  onClick={() => removeApp(v)}
                >
                  {t("common.uninstall")}
                </Button>
              ) : (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => installApp(v.id)}
                >
                  {t("common.install")}
                </Button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Empty />
        </div>
      )}
    </Modal>
  );
};
